import { Component, OnInit } from '@angular/core';
import { FormFieldAbstractComponent } from '../abstract.component';
import { provideTranslation } from '@skyeng/libs/shared/i18n';

@Component({
  selector: 'crm-form-field-number',
  templateUrl: './number.component.html',
  styleUrls: ['./number.component.scss'],
  viewProviders: [provideTranslation('formFieldNumber', () => import.meta.webpackContext!('./translation'))],
})
export class FormFieldNumberComponent extends FormFieldAbstractComponent implements OnInit {
  min: number;
  max: number;

  ngOnInit(): void {
    super.ngOnInit();

    this.setNumberRestrictions();
  }

  private setNumberRestrictions(): void {
    const min = this.formFieldsService.getValidatorConstraint(this.field, 'min');
    if (min !== undefined) {
      this.min = min;
    }

    const max = this.formFieldsService.getValidatorConstraint(this.field, 'max');
    if (max !== undefined) {
      this.max = max;
    }
  }
}
